export const USER_TITLES = ['Mr.', 'Mrs', 'Miss.', 'Ms.', 'Mx.'];
export const USER_TITLES_OPTIONS = [
    { value: 'Mr.', label: 'Mr.' },
    { value: 'Mrs.', label: 'Mrs.' },
    { value: 'Miss.', label: 'Miss.' },
    { value: 'Ms.', label: 'Ms.' },
    { value: 'Mx.', label: 'Mx.' }
];
